//import React from 'react';
import './Opinionwidget.scss';
import React, { useState , useRef} from 'react';
// let btnRef = useRef();
function OpinionWidget(props){
   
  const [count, setCount] = useState(0);
        //   const handleChange= (e) => {
        //     this.props.setStateOfParent(e.target); 
        // }

        const handleClick = (e) => {
         
            let OptionId = "";
            let groupId = "";
            let pollId = "";
           if(document.querySelector('input[name="opinion"]:checked') == null)
           return;
           
             OptionId = document.querySelector('input[name="opinion"]:checked').value;
             groupId = document.querySelector('input[name="opinion"]:checked').getAttribute('data');
             pollId = document.querySelector('div[class="quest_a_head"]').getAttribute('data');
             //console.log("option : ",OptionId )
            //  if(OptionId == null){
             
           // document.getElementsByClassName('q_a_result')[0].style.display = 'inline';

            var elems = document.getElementsByClassName('q_a_result');
            for (var i=0;i<elems.length;i+=1){
            elems[i].style.display = 'block';
}
            //   return;
            // }
             props.setStateOfParent(OptionId,groupId,pollId);
             document.querySelector('button').disabled = true;
             setCount(count + 1);
        }
        let PollList = props.dataFromParent;
       // let PollListData = PollList.filter((x)=>x.Type == "Poll");
    const _pollItems = PollList.map((item, i ) =>    
     <div className="news_widget_panel opinion_h_w" key = {i}>
      <div className="n_w_p_head">
                    <h2><label>{item.Title}</label></h2>
                </div>   
                <div className="n_w_p_body">
                   <div className="question_an_sect">
                {item.Items.map((item, i ) => 
                <div key={i}>
                   <div className="quest_a_head" data={item.ID }>
                     {item.Question}
                       </div>

     <div className="quest_a_body">
      {item.Options.map((item, i ) => 
             <div className="q_a_radio" key={i} >
             <span className="q_a_result" style={{'display' : 'none'}}>
                 <span className="q_a_progress" id={"poll_result_"+item.ID} style={{width : item.Percentage+"%" || item.vote_percent+"%"  , backgroundColor :item.option_color || "" }}></span>
                 <span className="q_a_prog_count">{Math.trunc(item.Percentage || item.vote_percent)}%</span>
             </span>
             <span className="q_a_radio_click">
                 <input type="radio" id={"radio"+i} name="opinion"  value={item.ID } data={item.GroupID || item.poll_id} 
                //  onChange= {(e) => SethandleChange(e.target.value)}
                //  onChange={handleChange}
                 />
                 <label htmlFor={"radio"+i}>{item.Option || item.option_name}</label>
             </span> 
         </div>
          )}
             <button  disabled={(count > 0 )? "disabled" : "" }  className="btn btn-block btn-outline-primary" onClick={handleClick}>{(count > 0 )? "Voted" : "Vote" }</button>
        </div>
     
        </div>
        
        )}
         
      </div>
      </div>
      </div>
       );
        return(
        
             <>
             {_pollItems}
             </>
           );
    }


export default OpinionWidget;
